import { render } from "./show_processing.vue?vue&type=template&id=bdbcf986"
import script from "./show_processing.vue?vue&type=script&lang=js"
export * from "./show_processing.vue?vue&type=script&lang=js"

import exportComponent from "/home/sophia/sophia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__